const e = {
  complex: "complexes",
  venue: "venues",
  billboard: "billboards",
  complexes: "complexes",
  venues: "venues",
  billboards: "billboards",
  empty_space: "empty_space",
  chain: "chains",
  tag: "tags",
  tags: "tags"
}, o = {
  ERROR_NOT_FOUND: "ERROR_NOT_FOUND",
  ERR_IN_PROGRESS: "ERR_IN_PROGRESS",
  POLYGON_TOO_SMALL: "POLYGON_TOO_SMALL",
  UNDELIVERABLE_ENTITY: "UNDELIVERABLE_ENTITY",
  QUOTA_EXCEEDED: "QUOTA_EXCEEDED"
}, p = (s) => !!s && typeof s == "object" && "backendError" in s, c = [
  {
    scope: "chain",
    sub_scope: "nationwide"
  },
  {
    scope: "chain",
    sub_scope: "state"
  },
  {
    scope: "chain",
    sub_scope: "cbsa"
  },
  {
    scope: "chain",
    sub_scope: "dma"
  },
  {
    scope: "primary",
    sub_scope: "nationwide"
  },
  {
    scope: "primary",
    sub_scope: "cbsa"
  },
  {
    scope: "primary",
    sub_scope: "dma"
  },
  {
    scope: "primary",
    sub_scope: "state"
  },
  {
    scope: "group",
    sub_scope: "nationwide"
  },
  {
    scope: "group",
    sub_scope: "cbsa"
  },
  {
    scope: "group",
    sub_scope: "dma"
  },
  {
    scope: "group",
    sub_scope: "state"
  }
];
export {
  o as API_ERRORS,
  p as isBackendError,
  e as pluralizeEntityTypes,
  c as rankTypes
};
//# sourceMappingURL=index.es263.js.map
